export const puedeCambiarEstado = (actas, actaSeleccionadaId, estadoCondicion) => {
  const index = actas?.findIndex((a) => a.id === actaSeleccionadaId);
  if (index === -1) return false;

  const actasAnteriores = actas?.slice(0, index);
  let actasPendientes = null;

  const actasPrev = actas?.slice(0, index);
  const actasPos = actas?.slice(index, actas?.length);

  const hayActasPendientes = actasAnteriores?.some((a) => a.estado_id === estadoCondicion);
  if (hayActasPendientes) {
    actasPendientes = actasAnteriores?.filter((a) => a.estado_id === estadoCondicion);
  }

  //   return !hayActasPendientes;
  return {
    puede: !hayActasPendientes,
    actasPendientes: actasPendientes,
    estadoCondicion: estadoCondicion,
    actasPrev,
    actasPos,
  };
};

export const cicloActas = (amp, actaId) => {
  const index = amp?.findIndex((a) => a.id === actaId);
  if (index === -1) return false;
  const actasPrev = amp?.slice(0, index);
  const actasPos = amp?.slice(index, amp?.length);
  return { actasPrev, actasPos };
};
